export default "__VITE_ASSET__CdTb$jGx__"